import {Loader2} from "lucide-react";

import {Button} from "@/components/ui/button";
import ImageCarousel from "@/components/ui/image-carousel";
import {DetailField} from "@/src/modules/core/components";
import {formatDate, formatTime} from "@/src/modules/core/lib/formatters";
import {BRIEF_READ_CTA} from "@/src/modules/briefing-boards/lib/brief-display";

type BriefingRecipientContentProps = {
  brief: string;
  createdBy: {name: string};
  createdAt: string;
  expiresAt?: string;
  media?: {files: string[]; thumb_files: string[]};
  showReadAction?: boolean;
  isMarkingRead?: boolean;
  onMarkRead?: () => void;
};

export function BriefingRecipientContent({
  brief,
  createdBy,
  createdAt,
  expiresAt,
  media,
  showReadAction = false,
  isMarkingRead = false,
  onMarkRead,
}: BriefingRecipientContentProps) {
  const mediaFiles = media?.files ?? [];
  const mediaThumbs = media?.thumb_files ?? [];

  return (
    <>
      <div className="grid gap-x-4 gap-y-3 sm:grid-cols-2">
        <DetailField label="Sent by">{createdBy.name}</DetailField>
        <DetailField label="Sent at">
          {formatDate(createdAt)} {formatTime(createdAt)}
        </DetailField>

        {expiresAt ? (
          <DetailField label="Valid until">
            {formatDate(expiresAt)} {formatTime(expiresAt)}
          </DetailField>
        ) : null}

        <DetailField label="Brief" className="sm:col-span-2">
          <p className="whitespace-pre-wrap break-words">{brief}</p>
        </DetailField>

        {mediaFiles.length > 0 ? (
          <DetailField label="Images" className="sm:col-span-2">
            <ImageCarousel images={mediaFiles} thumbnails={mediaThumbs} />
          </DetailField>
        ) : null}
      </div>

      {showReadAction && onMarkRead ? (
        <Button type="button" disabled={isMarkingRead} onClick={onMarkRead}>
          {BRIEF_READ_CTA}
          {isMarkingRead ? <Loader2 className="size-4 animate-spin" /> : null}
        </Button>
      ) : null}
    </>
  );
}
